import { useState } from 'react';
import { TaxData } from '../../../types/location';
import { Button, ButtonVariant } from '../../elements/Button';
import AddTaxRateModal from '../../modals/AddTaxRatesModal';
import TaxesFormTable from './TaxesFormTable';

interface TaxesContainerProps {
  partnerId: string;
  taxRatesDataResponse: TaxData[];
}

export const TaxesContainer = ({
  partnerId,
  taxRatesDataResponse,
}: TaxesContainerProps) => {
  const [openAddTaxRateModal, setOpenAddTaxRateModal] = useState(false);

  const handleOpenAddTaxRateModal = () => {
    setOpenAddTaxRateModal(!openAddTaxRateModal);
  };

  return (
    <div className='w-full mt-5 p-6 pb-2 bg-white  border border-gray-300 rounded-lg '>
      <div className='flex justify-between'>
        <h1 className='font-display text-xl font-semibold leading-7 tracking-normal text-left pb-6'>
          Taxes
        </h1>
        <Button
          variant={ButtonVariant.Default}
          onClick={() => {
            handleOpenAddTaxRateModal();
          }}
          label={'Add Tax Rate'}
          className='w-[129px] h-10 rounded-[39px]'
        />
      </div>
      <div className='whitespace-nowrap overflow-x-auto'>
        {!taxRatesDataResponse?.length ? (
          <p className='font-medium font-md text-gray-700'>
            No tax rates found for this location
          </p>
        ) : (
          <TaxesFormTable
            partnerId={partnerId}
            taxRatesDataResponse={taxRatesDataResponse}
          />
        )}
      </div>
      {openAddTaxRateModal && (
        <AddTaxRateModal
          handleOpenAddTaxRateModal={handleOpenAddTaxRateModal}
          partnerId={partnerId}
        />
      )}
    </div>
  );
};
